module.exports = __webpack_public_path__ + "img/DSC_2744 copy.36216a81.png";